import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerClient {

  private isLoaded = false;

  /**
   * Optional, can also be done via the <script> code provided by tag manager.
   */
  init(config: GoogleTagManagerConfig): Promise<boolean> {
    return this.initGoogleTagManager(config);
  }

  /**
   * Initializes the Google Tag Manager script (gtm.js). The below code behaves identical to
   * the code snippet that GTM itself proposes with the main advantage that the below can
   * be initialized at the moment it is required.
   */
  private initGoogleTagManager(config: GoogleTagManagerConfig): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.isLoaded) {
        return resolve(true);
      }

      this.initDataLayer();
      this.getDataLayer().push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });

      const params = new URLSearchParams({
        id: config.gtm_id,
        ...(config.gtm_auth && { gtm_auth: config.gtm_auth }),
        ...(config.gtm_preview && { gtm_preview: config.gtm_preview })
      });

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?${params}`;
      script.addEventListener('load', () => resolve((this.isLoaded = true)));
      script.addEventListener('error', () => reject(false));
      document.head.insertBefore(script, document.head.firstChild);
    });
  }

  private initDataLayer(): void {
    const windowRef = window as any;
    if (!windowRef.dataLayer) {
      windowRef.dataLayer = [];
    }
  }

  getDataLayer() {
    return (window as any).dataLayer as object[];
  }

}

export interface GoogleTagManagerConfig {
  readonly gtm_id: string;
  readonly gtm_auth?: string;
  readonly gtm_preview?: string;
}
